;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Card, CardImg, CardBody, CardTitle } from 'reactstrap';
import { Dictionaries } from '../i18n/i18n-config';
import { getI18nUtils } from '../i18n/i18n-utils';

type Props = {
  className: string;
  dictionary: Partial<Dictionaries>;
};
const HappyAtSynergie = ({ className, dictionary }: Props) => {
  function getRandomItem(arr) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  }
  const imagesArray = [
    '/images/RandomImage6.jpg',
    '/images/RandomImage5.jpg',
    '/images/RandomImage4.jpg',
    '/images/RandomImage3.jpg',
    '/images/RandomImage2.jpg',
    '/images/RandomImage1.jpg',
  ];
  const randomImage = getRandomItem(imagesArray);
  const { formatMessage } = getI18nUtils(dictionary);
  return (
    <Card className={`${className || ''}`}>
      <CardImg className="rounded-bottom-0" src={randomImage} title="Colleague at work" />
      <CardBody>
        <CardTitle tag="h3" className="happyAtSynergieTitle">
          {formatMessage({ id: 'job_happy_title' })}
        </CardTitle>
        <ul className="checkedList">
          <li className="happyAtSynergieListItem">{formatMessage({ id: 'job_happy_first_item' })}</li>
          <li className="happyAtSynergieListItem">{formatMessage({ id: 'job_happy_second_item' })}</li>
          <li className="happyAtSynergieListItem">{formatMessage({ id: 'job_happy_third_item' })}</li>
          <li className="happyAtSynergieListItem">{formatMessage({ id: 'job_happy_fourth_item' })}</li>
        </ul>
      </CardBody>
    </Card>
  );
};

export default HappyAtSynergie;
